import { Theme } from '@desygner/ui-common-components';

export const { Size, Radius, Spacing, Variant } = Theme.Button;
